import { FilterOptions } from "../collections/filter-options";
import { FilterOption } from "./filter-option";
import { FilterTerm } from "./filter-term";

var Filter = Backbone.Model.extend({
    defaults: {
        label: 'Products',
        sort_label: 'Recommended',
        sort_key: 'order',
        sort_order: 'asc',
        filter_settings: {},
        filter_options: null
    },
    initialize: function(){
        _.bindAll( this, 'register_filter_term', 'register_filter_option', 'updateSelections', 'updateSelection', 'updateHash', 'updateFilterFromHash', 'initialSettings' );
        let filter_options =  new FilterOptions();
        this.hash_settings= {};
        this.initialSettings();
        // this.selection = new Backbone.Collection();
        this.set({'filter_options': filter_options });

        this.listenTo( filter_options, 'change', this.updateSelections );
        this.listenTo( this, 'settings_updates', this.updateHash );

        this.listenTo( this, 'change:sort_order change:sort_key', _.debounce( this.updateHash, 1 ) );

    },
    initialSettings: function(){
        let settings = window.location.hash.length ? window.location.hash.substr(2).split( '/' ) : '';
        if ( settings.length ) {
            var option, key, val;
            for ( var i = 0; i < settings.length; i++ ){
                option = settings[i].split(':');
                if ( option.length == 2 ) {
                    key = option[0];
                    val = option[1];
                    switch ( key ) {
                        case 'orderby':
                            this.set({ 'sort_key' : val });
                            break;
                        case 'order':
                            this.set({ 'sort_order' : val });
                            this.trigger('initial_sort');
                            break; 
                        default:
                            
                            this.hash_settings[key] = val == 'true' ? true : decodeURI( val );
                            break;

                    }
                }
            }
        }
    },
    updateFilterFromHash: function( newSettings ){

        let currentFilters = this.get('filter_settings');
        var updateFilters = {};
        var filter_options = this.get( 'filter_options' );
        var updatesToSave = false;
        var option, newTerm;
        this.stopListening( filter_options, 'change', this.updateSelections );
        this.stopListening( this, 'settings_updates', this.updateHash );
        for ( var prop in currentFilters ) {
            // console.log( 'details', prop, currentFilters[prop], newSettings[prop] );
            if ( typeof newSettings[prop] === 'undefined' && _.isNull( currentFilters[prop] ) ) { 
                // nothing here
                // console.log( 'condition a' );
                updateFilters[prop] = currentFilters[prop];
            } else if ( typeof newSettings[prop] === 'undefined' && !_.isNull( currentFilters[prop] ) ) {
                // console.log( 'condition b' );
                option = filter_options.findWhere({ key : prop });
                newTerm = option.get('terms').findWhere({ 'selected' : true });
                if ( newTerm ) {
                    newTerm.set({'selected' : false });
                    // option.set({ 'selection' : null });
                }
                updateFilters[prop] = null;
                updatesToSave = true;
            } else if ( currentFilters[prop] !== newSettings[prop] ) {
                // console.log( 'condition c' );
                option = filter_options.findWhere({ key : prop });
                newTerm = option.get('terms').findWhere({ 'value' : newSettings[prop] });
                if ( newTerm ) {
                    newTerm.set({'selected' : true });
                    // option.set({ 'selection' : newTerm.get('value') });
                }
                updateFilters[prop] = newSettings[prop];
                updatesToSave = true;
            } else {
                // console.log( 'condition e' );
                updateFilters[prop] = currentFilters[prop];
            }
        }
        this.listenTo( filter_options, 'change', this.updateSelections );
        if ( updatesToSave ) {
            // console.log( 'updateToSave', updateFilters );
            this.set({'filter_settings' : updateFilters });
            filter_options.trigger( 'change' );
        }
        this.listenTo( this, 'settings_updates', this.updateHash );
    },
    updateHash: function(){
        let newHash = '';
        let filters = this.get('filter_settings');
        for ( var prop in filters ) {
            var filterVal = Object.hasOwn(filters, prop) ? filters[prop] : false;
            if ( typeof filterVal !== 'undefined' && filterVal ) {
                newHash = newHash + '/' + prop + ':' + filterVal;
            }
        }
        
        let sort_key = this.get( 'sort_key' );
        newHash = newHash + '/orderby:' + sort_key;

        let sort_order = this.get( 'sort_order' );
        newHash = newHash + '/order:' + sort_order;
        
        // console.log( 'update hash', newHash );
        window.location.hash = newHash;
        // history.pushState( filters, '', window.location.href );
    },
    /*
    Register a new filter option
    */
    register_filter_option: function( o ){
        var filter_options = this.get( 'filter_options' );
        var filter_settings = this.get( 'filter_settings' );
        var opt = filter_options.findWhere({ 'key' : o.key });
        if ( _.isEmpty(  opt ) ) {
            opt = new FilterOption( o );
            filter_options.add( opt );
            var v = typeof this.hash_settings[o.key] !== 'undefined' ? this.hash_settings[o.key] : null; 
            filter_settings[o.key] = v;
            this.set( { 'filter_settings': filter_settings } );
        }
    },
    /*
    Register a new filter term in an option key
    */
    register_filter_term: function( term, key ){
        var filter_options = this.get( 'filter_options' );
        // check the collection, if not present, add it.
        var opt = filter_options.findWhere({ 'key' : key });
        var t = opt.get( 'terms' );
        var existing = t.findWhere({ 'value' : term });
        if ( ! existing ) {
            // add the term
            var type = opt.get( 'type' );
            if ( type == 'checkbox' && !term ) {
                // skip it, checkboxes can only be true
                return;
            }
            // stop listening while we update this, so we can prevent infinite loops and such.
            this.stopListening( filter_options, 'change', this.updateSelections );
            var name = type == 'checkbox' ? opt.get( 'label' ): term;
            var y = { 'name' : name, 'value': term };
            if ( typeof this.hash_settings[key] !== 'undefined' && this.hash_settings[key] == term ) {
                y.selected = true;
                opt.set( { 'selection' : term } );
            }
            var newTerm = new FilterTerm( y );
            t.add( newTerm );
            if ( y.selected && opt.get( 'main' ) ) {
                var label = newTerm.get('name');
                this.set( { 'label' : label } );
            }

            // start listening again
            this.listenTo( filter_options, 'change', this.updateSelections );
        }
    },
    /*
    Update the filter settings when the collection of options is changed.
    */
    updateSelections: function(){
        var filter_options = this.get( 'filter_options' );
        // let's pause listening to changes on the options, since we maybe clearing some of them out.
        this.stopListening( filter_options, 'change', this.updateSelections );

        // loop over all the option models in the collection
        filter_options.each( this.updateSelection );

        // to allow other elements to listen to this event for refresh.
        this.trigger( 'settings_updates' );

        // this.updateHash();

        // once we are done, we can start listening again.
        this.listenTo( filter_options, 'change', this.updateSelections );
    },
    /*
    Update a filter setting with the new value.
    If the conditions are not met to show this filter option, 
    clear the selection and set the filter settings for this option key to null
    */
    updateSelection: function( option ){
        let settings = this.get( 'filter_settings' );
        var conditions = option.get( 'conditions' );
        let key = option.get('key');
        let val = option.get('selection');
        let main = option.get('main');


        if ( main ) {
            // let label = option.get('label');
            this.set({'label' : val });
        }
        // window.debugLogger( val, key, conditions );

        // if this option has conditions, we need to check they are met to still show.
        if ( !_.isEmpty(conditions) ) {
            var conds = Object.keys( conditions );
            var k, v, x, t;
            for ( var i = 0; i < conds.length; i++ ) {
                k = conds[i];
                v = settings[k];
                x = conditions[k];

                // window.debugLogger( k, v, x );
                // for each condition if not empty
                if ( !_.isEmpty( x ) ) {
                    // window.debugLogger( 'conditions present', k );
                    // check to see the the condition array contains the value of that setting, or if not an array is the value ==
                    if ( ( _.isArray( x ) && ! x.includes( v ) ) || ( !_.isArray(x) && x !== v ) ){
                        // if not, we should clear this setting.
                        val = null;

                        // window.debugLogger( 'conditions met to clear', key, k );
                        option.set({'selection': null });
                        t = option.get('terms').findWhere({'selected' : true});
                        if ( t ) {
                            t.set({ 'selected' : false });
                        }
                        break;
                    }
                }
            }
        }
        // finally update the setting from the selection of that option.
        if ( settings[key] !== val ) {
            settings[key] = val;
            this.set( {'filter_settings' : settings} );
        }
        
    }
});
export {Filter};